<template>
  <div class="return-list" ref="container">
    <div class="goodWrapper" v-for="order in orderList" :key="order.id">
      <div
        class="iconfont icon-tuikuanzhong powder"
        v-if="order.status === -1"
      ></div>
      <div class="iconfont icon-yituikuan" v-if="order.status === -2"></div>
      <div class="orderNum">订单号：{{ order.orderSn }}</div>
      <div
        class="item acea-row row-between-wrapper"
        v-for="cart in order.productItems"
        :key="cart.id"
        @click="$router.push({ path: '/order/detail/' + order.id })"
      >
        <div class="pictrue">
          <img
            :src="cart.productPic"
            class="image"
            @click.stop="$router.push({ path: '/detail/' + cart.productId })"
          />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1">{{ cart.productName }}</div>
            <div class="num">x {{ cart.productQuantity }}</div>
          </div>
          <!--
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>
          <div class="attr line1" v-else>{{ cart.productName }}</div>
          -->
          <div class="money">￥{{ cart.productPrice }}</div>
        </div>
      </div>
      <div class="totalSum">
        共{{ order.productItems.length || 0 }}件商品，总金额
        <span class="font-color-red price">￥{{ order.payAmount }}</span>
      </div>
    </div>
    <div class="noCart" v-if="orderList.length === 0 && page > 1">
      <div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>

<script>
import { getOrderList } from "@api/order";
import Loading from "@components/Loading";
import { mapGetters } from "vuex";

export default {
  name: "ReturnList",
  components: {
    Loading,
  },
  data() {
    return {
      orderList: [],
      page: 1,
      limit: 20,
      loading: false,
      loaded: false,
    };
  },
  computed: mapGetters(["userInfo"]),
  watch: {
    userInfo: {
      handler(val, oldVal) {
        this.getOrderList();
      },
    },
  },
  methods: {
    getOrderList() {
      const { page, limit } = this;
      if (this.loading || this.loaded) return;
      this.loading = true;
      getOrderList({
        page,
        limit,
        type: -3,
      }).then((res) => {
        console.info(res.result.records);
        this.orderList = this.orderList.concat(res.result.records);
        console.info(this.orderList);
        this.loading = false;
        this.loaded = res.result.pageSize < limit;
        this.page++;
      });
    },
  },
  mounted() {
    this.getOrderList();
    this.$scroll(this.$refs.container, () => {
      !this.loading && this.getOrderList();
    });
  },
};
</script>

<style scoped>
.noCart {
  margin-top: 0.17rem;
  padding-top: 0.1rem;
}

.noCart .pictrue {
  width: 4rem;
  height: 3rem;
  margin: 0.7rem auto 0.5rem auto;
}

.noCart .pictrue img {
  width: 100%;
  height: 100%;
}
</style>
